import React from "react";
import { Inbox, TrendingUp, Eye, Clock, Hash } from "lucide-react";
import { propertyHero } from "../../data/offerData";

const stat = (label, value, sub, icon) => ({ label, value, sub, icon });

export const OfferHeader = () => {
  const items = [
    stat("Asking price", propertyHero.asking, propertyHero.type, null),
    stat("Offers received", propertyHero.offers, "All within 6 days", Inbox),
    stat("Best offer", propertyHero.bestOffer, propertyHero.bestPremium, TrendingUp),
    stat("Avg offer strength", `${propertyHero.avgStrength}/100`, "Above network mean", Hash),
    stat("Viewings", propertyHero.viewings, "14.8% conversion", Eye),
    stat("Days on market", propertyHero.daysOnMarket, "Network avg 26d", Clock),
  ];

  return (
    <header className="sticky top-0 z-30 glass-light border-b cf-divider-soft" data-testid="offer-header">
      <div className="px-4 md:px-10 pt-7 pb-2.5 flex items-center gap-1.5 text-[12px] text-slate-500">
        <span>Offer Intelligence</span>
        <span className="opacity-40">·</span>
        <span>London</span>
        <span className="opacity-40">·</span>
        <span className="text-slate-900 font-medium">{propertyHero.address}</span>
        <span className="ml-3 cf-num text-[10.5px] text-slate-400">{propertyHero.reference}</span>
      </div>

      <div className="px-4 md:px-10 pb-5 md:pb-7 flex items-start gap-6">
        <div className="hidden md:block w-[96px] h-[96px] rounded-2xl overflow-hidden ring-1 ring-slate-200 shrink-0" style={{ boxShadow: "var(--cf-elev-2)" }}>
          <img src={propertyHero.image} alt={propertyHero.address} className="w-full h-full object-cover" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3 flex-wrap">
            <h1 className="cf-h-page" data-testid="offer-property-address">
              {propertyHero.address}
            </h1>
            <span className="inline-flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-[0.16em] px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-100">
              <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 cf-pulse" />
              Live offer round
            </span>
          </div>
          <p className="text-[13px] text-slate-500 mt-1.5">{propertyHero.city} · {propertyHero.postcode} · {propertyHero.type}</p>

          <div className="mt-5 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            {items.map((it) => {
              const Icon = it.icon;
              return (
                <div key={it.label} data-testid={`offer-stat-${it.label}`} className="rounded-xl bg-white border border-[color:var(--cf-border)] p-3.5 transition-all hover:border-slate-300" style={{ boxShadow: "var(--cf-elev-1)" }}>
                  <div className="flex items-center gap-1.5 text-slate-500">
                    {Icon && <Icon size={11} />}
                    <p className="text-[10px] uppercase tracking-[0.16em] font-semibold">{it.label}</p>
                  </div>
                  <p className="font-display text-[18px] font-bold text-slate-900 mt-2 leading-none tracking-tight">{it.value}</p>
                  <p className="text-[10.5px] text-slate-500 mt-1.5 truncate">{it.sub}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </header>
  );
};
